import { type PlatformEvent } from '../types';

export const makeGameSessionClickEvent = (
  gameKey: string,
  source?: string
): PlatformEvent => ({
  type: 'click',
  user_properties: {},
  event_properties: { name: 'game_session_start', game_key: gameKey, source },
});

export const makeGameSessionStartEvent = (
  gameKey: string,
  source?: string,
  trigger: 'click' | 'auto' = 'click'
): PlatformEvent => ({
  type: 'game_session_start',
  user_properties: {},
  event_properties: { name: 'game_session_start', game_key: gameKey, source, trigger },
});
